export const initialState = { selectedIndex: 0 };

const keysReducer = (
  state: { selectedIndex: number },
  action: {
    type: string;
    payload: {
      index?: number;
      list?: string[];
    };
  }
) => {
  const { index = 0, list = [] } = action.payload;

  switch (action.type) {
    case "arrowUp":
      return {
        selectedIndex: state.selectedIndex !== 0 ? state.selectedIndex - 1 : list.length - 1,
      };
    case "arrowDown":
      return {
        selectedIndex: state.selectedIndex !== list.length - 1 ? state.selectedIndex + 1 : 0,
      };
    case "select":
    default:
      return { selectedIndex: index };
  }
};

export { keysReducer };
